/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   full name validator
 */

import * as Yup from 'yup'

const ERROR_FULL_NAME = 'Please enter your full name'
const ERROR_LAST_NAME = 'Please add your last name'
const ERROR_INVALID_NAME = 'Please enter a valid name'

// ref: https://stackoverflow.com/questions/150033/regular-expression-to-match-non-ascii-characters#comment19644791_150078
const NameValidator = /^[\u00BF-\u1FFF\u2C00-\uD7FF\w ,.'-]+$/i

export const fullNameValidator = Yup.string()
  .required(ERROR_FULL_NAME)
  .test({
    message: ERROR_FULL_NAME,
    test: (name) => {
      if (name) {
        const trimmed = name.trim().replace(/\s+/g, ' ')
        if (!trimmed) {
          return false
        }
        const nameParts = trimmed.split(' ')
        return nameParts.length !== 0
      }
      return true
    },
  })
  .test({
    message: ERROR_LAST_NAME,
    test: (name) => {
      if (name) {
        const trimmed = name.trim().replace(/\s+/g, ' ')
        const nameParts = trimmed.split(' ')
        return nameParts.length !== 1
      }
      return true
    },
  })
  .test({
    message: ERROR_INVALID_NAME,
    test: (name) => {
      return typeof name === 'string' && NameValidator.test(name)
    },
  })
